import React, { useState } from "react";

export default function Ratingscale({
  quesId,
  maxRating,
  onRatingChange,
  ctrlName,
}) {
  const [rating, setRating] = useState(0);

  const handleStarClick = (selectedRating) => {
    setRating(selectedRating);
    onRatingChange(quesId, selectedRating, ctrlName,0);
  };

  return (
    <div>
      {onRatingChange && (
        <div>
          {[...Array(maxRating).keys()].map((index) => (
            <span
              key={index}
              onClick={() => handleStarClick(index + 1)}
              style={{
                cursor: "pointer",
                color: index + 1 <= rating ? "gold" : "gray",
                fontSize: "50px",
              }}
            >
              &#9733; {/* &#9733; Unicode character for a star */}
            </span>
          ))}
        </div>
      )}
      {!onRatingChange && (
        <div>
          {[...Array(maxRating).keys()].map((index) => (
            <span
              key={index}
              style={{
                cursor: "pointer",
                color: "gold",
                fontSize: "50px",
              }}
            >
              &#9733; {/* &#9733; Unicode character for a star */}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
